// Copy paste this template to create a new component
// that can be put into the masonry layout!

import * as React from "react";
import { css } from "emotion";
import Card from "./Card";
import { HorizontalBar, defaults, Bar } from "react-chartjs-2";
import { labeledStatement } from "@babel/types";
import { mediaQueries } from "../../shared/config";

const barChartOptions = {
  maintainAspectRatio: false,
  responsive: true,
  legend: {
    display: true
  },
  scales: {
    xAxes: [
      {
        display: true,
        position: "bottom",
        scaleLabel: {
          display: true,
          labelString: "Race/Ethnicity"
        },
        ticks: {
          autoSkip: false,
          maxRotation: 45,
          minRotation: 45
        }
      }
    ],
    yAxes: [
      {
        ticks: {
          callback: function(label) {
            if (/\s/.test(label)) {
              if (label.split(" ").length > 2) {
                label = label.split(" ");
                label[1] = label[0] + " " + label[1];
                label.shift();
                return label.map(l => l + '%');
              } else {
                return label.split(" ").map(l => l + '%');
              }
            } else {
              return label + '%';
            }
          }
        },
        stacked: false,
        display: true,
        scaleLabel: {
          display: true,
          labelString: "Percent of Students"
        }
      }
    ]
  },
  title: {
    display: false,
    text: "UCLA vs. Daily Bruin Race/Ethnicity Breakdown"
  },
  tooltips:{
    callbacks:{
      label: function(tooltipItem){
        return this._data.datasets[tooltipItem.datasetIndex].label +': ' + tooltipItem.yLabel + '%';
      }
    }
  }
};

interface EthnicitySectionBreakdownProps{
  caption: Array<string>;
}

class EthnicitySectionBreakdownBarChartCard extends React.Component <EthnicitySectionBreakdownProps>{
  constructor(props:EthnicitySectionBreakdownProps){
    super(props);
  }
  state = {
    labels: ["Black or African American",
          "White",
          "Hispanic or Latino",
          "Native American or American Indian",
          "Asian/Pacific Islander",
          "Middle Eastern",
          "Multiracial",
          "Prefer not to say"],
          datasets: [
            {
              data: [
                (3/61*100).toFixed(2), //   "Black or African American",
                (20/61*100).toFixed(2), //  "White",
                (4/61*100).toFixed(2), //   "Hispanic or Latino",
                (0/61*100).toFixed(2), //   "Native American or American Indian",
                (20/61*100).toFixed(2), //  "Asian/Pacific Islander",
                (1/61*100).toFixed(2), //   "Middle Eastern",
                (12/61*100).toFixed(2), //   "Multiracial",
                (1/61*100).toFixed(2), //   "Prefer not to say"
              ],
              backgroundColor: "#0080C6",
              label: "Editors"
            },
            {
              data: [
                (1/43*100).toFixed(2), //   "Black or African American",
                (14/43*100).toFixed(2), //  "White",
                (3/43*100).toFixed(2), //   "Hispanic or Latino",
                (0/43*100).toFixed(2), //   "Native American or American Indian",
                (21/43*100).toFixed(2), //  "Asian/Pacific Islander",
                (2/43*100).toFixed(2), //   "Middle Eastern",
                (1/43*100).toFixed(2), //   "Multiracial",
                (1/43*100).toFixed(2), //   "Prefer not to say"
              ],
              backgroundColor: "#c377e0",
              label: "Paid staff",
            },
            {
              data: [
                (3/91*100).toFixed(2), //   "Black or African American",
                (26/91*100).toFixed(2), //  "White",
                (15/91*100).toFixed(2), //   "Hispanic or Latino",
                (0/91*100).toFixed(2), //   "Native American or American Indian",
                (25/91*100).toFixed(2), //  "Asian/Pacific Islander",
                (4/91*100).toFixed(2), //   "Middle Eastern",
                (14/91*100).toFixed(2), //   "Multiracial",
                (4/91*100).toFixed(2), //   "Prefer not to say"
              ],
              backgroundColor: "#56B9EF",
              label: "Unpaid contributors",
            },
            {
              data: [
                (0/51*100).toFixed(2), //   "Black or African American",
                (12/51*100).toFixed(2), //  "White",
                (4/51*100).toFixed(2), //   "Hispanic or Latino",
                (0/51*100).toFixed(2), //   "Native American or American Indian",
                (26/51*100).toFixed(2), //  "Asian/Pacific Islander",
                (1/51*100).toFixed(2), //   "Middle Eastern",
                (6/51*100).toFixed(2), //   "Multiracial",
                (2/51*100).toFixed(2), //   "Prefer not to say"
              ],
              backgroundColor: "#733B90",
              label: "Fall 2023 interns",
            },
            {
              data: [
                (2/43*100).toFixed(2), //   "Black or African American",
                (20/43*100).toFixed(2), //  "White",
                (3/43*100).toFixed(2), //   "Hispanic or Latino",
                (0/43*100).toFixed(2), //   "Native American or American Indian",
                (10/43*100).toFixed(2), //  "Asian/Pacific Islander",
                (3/43*100).toFixed(2), //   "Middle Eastern",
                (5/43*100).toFixed(2), //   "Multiracial",
                (0/43*100).toFixed(2), //   "Prefer not to say"
              ],
              backgroundColor: "#25E6D1",
              label: "Winter 2024 interns",
            },
          ]
        };

  render() {
    const { mobile } = mediaQueries;
    defaults.global.defaultFontColor = "#0a0a0a";
    const caption = this.props.caption;
    return (
      <Card>
        <div
          className={css`
            font-size: 30px;
            text-align: center;
            margin-bottom: 5px;
            ${mobile} {
              font-size: 18px;
            }
          `}
        >
          Staff level race/ethnicity breakdowns
        </div>
        <div
          className={css`
            height: 500px;
            ${mobile} {
              height: 600px;
            }
            width: 100%;
          `}
        >
          <Bar
            data={this.state}
            options={{
              ...barChartOptions
            }}
          />
        </div>
        <div className={css`
            font-size: 15px;
            margin: 10px;
            color: black;
            text-align: left;
          `}>
          {caption}
          </div>
      </Card>
    );
  }
}

export default EthnicitySectionBreakdownBarChartCard;
